export default "__VITE_ASSET__CS1I3LN1__"